module.exports = ".wrapper{margin-bottom:30px}label{font-size:1.1428rem;font-weight:bold;color:#2a2a2a}hr{margin:0 0 20px}"